module.exports = __webpack_public_path__ + "img/chat.1b560197.svg";